/**
 * browser helper library
 * adds helper classes in the form of is-[value] to the html tag
 * @author Tobias Schubert (ts@taikonauten.com)
 */
import '../shims/class-list';

import {elHTML} from '../config/vars';

class Browser {

  constructor() {
    this.init();
  }

  init() {
    this.browser = {
      major: ''
    };
    this.device = {
      type: 'desktop'
    };
    this.os = {};
    this.browserName = '';

    if (window.matchMedia) {
      if (matchMedia('(max-width: 48em)').matches) {
        this.device.type = 'tablet';
      }
      if (matchMedia('(max-width: 25em)').matches) {
        this.device.type = 'mobile';
      }
    }

    switch (true) {
    default:
      break;

    case !!document.all && !window.atob:
      this.browserName = 'IE';
      this.browser.major = '9';
      this.isIE = true;
      break;

    case navigator.userAgent.indexOf('MSIE 10.0') > -1:
      this.browserName = 'IE';
      this.browser.major = '10';
      this.isIE = true;
      break;

    case navigator.userAgent.indexOf('rv:11.0') > -1:
      this.browserName = 'IE';
      this.browser.major = '11';
      break;

    case navigator.userAgent.indexOf('Edge/') > -1:
      this.browserName = 'Edge';
      break;

    case navigator.userAgent.indexOf('Chrome/') > -1:
      this.browserName = 'Chrome';
      break;

    case navigator.userAgent.indexOf('iPhone OS/') > -1:
      this.browserName = 'Safari';
      this.os.name = 'iOS';
      break;

    case !!(navigator.userAgent.match(/(iPad)/) /* iOS pre 13 */ || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)):
      this.browserName = 'Safari';
      this.os.name = 'iOS';
      this.device.type = 'tablet';
      break;

    case navigator.userAgent.indexOf('Safari/') > -1:
      this.browserName = 'Safari';
      break;

    case navigator.userAgent.indexOf('Firefox/') > -1:
      this.browserName = 'Firefox';
      break;

    }

    if (navigator.userAgent.indexOf('Android') > -1) {
      this.os.name = 'Android';
    }

    this.browser.name = this.browserName;

    // indicates if this device has touch event support
    this.isTouch = elHTML.classList.contains('touchevents');

    // if the operating system is known
    if (this.os.name) {
      elHTML.classList.add(this.getFormattedString(this.os.name));
    }

    // if browser name is known
    if (this.browser.name) {
      elHTML.classList.add(this.getFormattedString(this.browser.name));
    }

    // if the browser version is known
    if (this.browser.version) {
      // add the helper class for the major version (e.g.: is-chrome-43)
      elHTML.classList.add(this.getFormattedString(this.browser.name + ' ' + this.browser.version));
    }

    // if the device model is known
    if (this.device.model) {
      elHTML.classList.add(this.getFormattedString(this.device.model));
    }

    this.setBrowser();
  }

  /**
   * set a member variable in the form of is[CurrentBrowser].
   * e.g.: If the current browser is Firefox the member variable isFirefox equals to true.
   */
  setBrowser() {
    this['is' + this.browserName] = true;
  }

  /**
   * @param {String} str
   * returns the formatted string that is used as our html helper class.
   * @returns {String}
   */
  getFormattedString(str) {
    return 'is-' + str.toLowerCase().replace(/\s+/g, '-');
  }
}

window.Browser = new Browser();
